module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/hn-ebef2cd564ca07f12aa10d84048e0496.svg";